module.exports = __webpack_public_path__ + "assets/filters-d4e14b.svg";